var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.frame)?_c('InteractiveCanvas',{attrs:{"frame":_vm.frame,"stretch-mode":"contain"},on:{"loaded":_vm.interactiveCanvasLoaded,"mounted":_vm.interactiveCanvasMounted,"wheel":_vm.handleWheel}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }